import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-701bc300"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_3 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_4 = { class: "p-field p-col-12 p-md-3 p-lg-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Họ và tên", -1))
const _hoisted_6 = {
  key: 0,
  class: "p-error"
}
const _hoisted_7 = { class: "p-field p-col-12 p-md-3 p-lg-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Địa chỉ", -1))
const _hoisted_9 = { class: "p-field p-col-12 p-md-3 p-lg-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn Tỉnh/Thành phố", -1))
const _hoisted_11 = {
  key: 0,
  class: "p-error"
}
const _hoisted_12 = { class: "p-field p-col-12 p-md-3 p-lg-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn Xã/Phường", -1))
const _hoisted_14 = {
  key: 0,
  class: "p-error"
}
const _hoisted_15 = { class: "p-field p-col-12 p-md-3 p-lg-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Số điện thoại", -1))
const _hoisted_17 = {
  key: 0,
  class: "p-error"
}
const _hoisted_18 = { class: "p-field p-col-12 p-md-3 p-lg-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Đăng ký", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Đăng ký thông tin khách hàng" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Panel, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(_component_InputText, {
                    id: "fullname",
                    type: "text",
                    modelValue: $setup.customerUpdate.FullName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.customerUpdate.FullName) = $event)),
                    style: {"text-align":"center"}
                  }, null, 8, ["modelValue"]),
                  (!$setup.customerUpdate.FullName)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_6, "Vui lòng nhập họ và tên"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_InputText, {
                    id: "number",
                    type: "text",
                    modelValue: $setup.customerUpdate.Address,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.customerUpdate.Address) = $event)),
                    style: {"text-align":"center"}
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_Dropdown, {
                    id: "province",
                    filter: true,
                    showClear: true,
                    modelValue: $setup.province.provinceCode,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.province.provinceCode) = $event)),
                    options: $setup.listProvince,
                    optionLabel: "provinceName",
                    optionValue: "provinceCode",
                    placeholder: "Vui lòng lựa chọn tỉnh/thành phố...",
                    onChange: $setup.loadListWard
                  }, null, 8, ["modelValue", "options", "onChange"]),
                  (!$setup.province.provinceCode)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_11, "Vui lòng chọn tỉnh/thành phố"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_Dropdown, {
                    id: "ward",
                    filter: true,
                    showClear: true,
                    modelValue: $setup.ward.wardCode,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.ward.wardCode) = $event)),
                    options: $setup.listWard,
                    optionLabel: "wardName",
                    optionValue: "wardCode",
                    placeholder: "Vui lòng lựa chọn xã/phường..."
                  }, null, 8, ["modelValue", "options"]),
                  (!$setup.ward.wardCode)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_14, "Vui lòng chọn xã/phường"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_InputText, {
                    id: "birthday",
                    type: "text",
                    modelValue: $setup.customerUpdate.PhoneNumber,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.customerUpdate.PhoneNumber) = $event)),
                    style: {"text-align":"center"}
                  }, null, 8, ["modelValue"]),
                  (!$setup.customerUpdate.PhoneNumber)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_17, "Vui lòng nhập số điện thoại"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  ($setup.valid)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        label: "Xác nhận",
                        icon: "pi pi-check-circle",
                        iconPos: "left",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.doRegister()))
                      }))
                    : (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        label: "Xác nhận",
                        icon: "pi pi-check-circle",
                        iconPos: "left",
                        disabled: "disabled"
                      }))
                ])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}